import nl2br from 'react-nl2br';
import { Balloon } from '~/app/(default-layout)/s/[storyId]/_components/chat-script-render/op/balloon';
import type { PostMessage as PostMessageOp } from '~/app/_types/chat-script';
import type { BoxProps } from '@styled-system/jsx';

type Props = {
  op: PostMessageOp;
} & BoxProps;

export const PostMessage = ({ op, ...boxProps }: Props) => (
  <Balloon
    {...boxProps}
    character={op.character}
    withTip={op.viewType === 'chat'}
  >
    {nl2br(op.text)}
  </Balloon>
);
